import React, { useEffect, useRef, useState } from 'react'
import { Popup } from 'antd-mobile'
import general from '../../../general'
import './css/GrowthRecord.css'

export default function DisableGames(props) {

  const [visible, setVisible] = useState(false)
  const [list, setList] = useState([])
  const [notlist, setNotList] = useState([])
  const inputRef = useRef()

  useEffect(() => {
    setVisible(props.visible)
    if (props.visible) {
      honorGetUseAppGameList()
      honorGetNotApplicableList()
    }
  }, [props.visible])

  const honorGetUseAppGameList = () => {
    general.axios.post('/honorGetUseAppGameList', {
      search_info: inputRef.current?.value
    }).then(res => {
      setList(res.data.data.list)
    })
  }

  const honorGetNotApplicableList = () => {
    general.axios.post('/honorGetNotApplicableList', {
      search_info: inputRef.current?.value
    }).then(res => {
      setNotList(res.data.data.list)
    })
  }

  const handleSearch = () => {
    honorGetUseAppGameList()
    honorGetNotApplicableList()
  }

  return (
    <div>
      <Popup
        visible={visible}
        onMaskClick={()=>{
          props.handleDismiss()
          inputRef.current.value = ''
          setList([])
          setNotList([])
        }}
        bodyStyle={{
          borderTopLeftRadius: '13px',
          borderTopRightRadius: '13px',
        }}
      >
        <div className='disable-game-index'>
          <div className="close" onClick={() => props.handleDismiss()}>
          </div>
          <div className="header">
            <div className="title">查询不可用游戏</div>
          </div>
          <div className="search">
            <div className="input">
              <input type="text" ref={inputRef} placeholder='查询不可用游戏' />
            </div>
            <div className="search" onClick={handleSearch}>搜索</div>
          </div>
          <div className="games">
            {list.length > 0 && <div className="header">在玩的游戏可用</div>}
            <div className="game-list">
              {list.map(item => {
                return (
                  <div className="item use">
                    <img className='icon' src={item.game_image.thumb} alt="" />
                    <div className="gamename">{item.game_name}</div>
                    <div className="remark">{item.nameRemark}</div>
                  </div>
                )
              })}
            </div>
            {notlist.length > 0 && <div className="header">以下游戏暂不可用</div>}
            {notlist.length > 0 && <div className="desc">已筛选查询结果</div>}
            {notlist.length > 0 && <div className="game-list">
              {notlist.map(item => {
                return (
                  <div className="item">
                    <img className='icon' src={item.game_image.thumb} alt="" />
                    <div className="gamename">{item.game_name}</div>
                    <div className="remark" style={{visibility:item.nameRemark ? 'visibility' : ' hidden'}}>{item.nameRemark}</div>
                  </div>
                )
              })}
            </div>}
            {notlist.length == 0 && list.length == 0 && inputRef?.current?.value?.length > 0 && <div className="empty"><img src="/resources/empty.png" alt=""/>暂无数据</div>}
          </div>
          <div className="btn" onClick={() => {
            props.handleDismiss()
            inputRef.current.value = ''
            setList([])
            setNotList([])
          }}>我知道了</div>
        </div>
      </Popup>
    </div>
  )
}
